"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconChevronDownCircle = _interopRequireDefault(require("./IconChevronDownCircle"));
var IconChevronRightCircle = /*#__PURE__*/(0, _styledComponents.default)(_IconChevronDownCircle.default).withConfig({
  displayName: "IconChevronRightCircle",
  componentId: "c11n-8-107-0__sc-12a0y0y-0"
})(["transform:rotate(270deg);"]);
var _default = IconChevronRightCircle;
exports.default = _default;